export const validateTimesheetForm = (formValues, options = {}) => {
    const { requireTransport = true } = options;
    const action = formValues.action || 'save'; // Default action is 'save' if not provided
    if (!formValues.mission_planning_id) {
        return {
            valid: false,
            message: 'Veuillez sélectionner un planning de mission.'
        };
    }

    if (action === 'update' && !formValues.mission_timesheet_id) {
        return {
            valid: false,
            message: 'L\'ID de la timesheet de la mission est manquant.'
        };
    }

    if(!formValues.mission_planning_agenda_id) {
        return {
            valid: false,
            message: 'L\'ID de l\'agenda de la planification de la mission est manquant.'
        };
    }
    if (!Array.isArray(formValues.timesheet_destinations) || formValues.timesheet_destinations.length === 0) {
        return {
            valid: false,
            message: 'Veuillez ajouter au moins une entrée de feuille de temps.'
        };
    }   
    for (let i = 0; i < formValues.timesheet_destinations.length; i++) {
        const entry = formValues.timesheet_destinations[i];
        if(!entry.region_depart || !entry.district_depart || !entry.commune_depart) {
            return {
                valid: false,   
                message: `Veuillez renseigner la localisation de départ jusqu’à la commune pour la ligne ${i + 1}.`
            };
        }

        if(!entry.region_arrivee || !entry.district_arrivee || !entry.commune_arrivee) {
            return {
                valid: false,
                message: `Veuillez renseigner la localisation d'arrivée jusqu’à la commune pour la ligne ${i + 1}.`
            };
        }

        if(entry.distance_km < 0) {
            return {
                valid: false,
                message: `Veuillez entrer un kilométrage valide pour la ligne ${i + 1}.`
            };
        }

        if(requireTransport && !entry.transport_type){
            return {
                valid: false,
                message: `Veuillez sélectionner un moyen de transport pour la ligne ${i + 1}.`
            };
        }
    }
    return { valid: true };
};

export const validateRentForm = (formValues, options = {}) => {
    const { requireDirection = false } = options;
    if(requireDirection && !formValues.direction_id) {
        return {
            valid: false,
            message: 'Veuillez sǸlectionner une direction.'
        };
    }
    if(!formValues.rent_type) {
        return {
            valid: false,
            message: 'Veuillez sélectionner un type de location.'
        };
    }
    // if(!formValues.rent_amount || formValues.rent_amount <= 0) {
    //     return {
    //         valid: false,
    //         message: 'Veuillez entrer un montant de location valide.'
    //     };
    // }
    if(!formValues.rent_paiement) {
        return {
            valid: false,
            message: 'Veuillez sélectionner un mode de paiement.'
        };
    }
    // if(!formValues.rent_upfuel || formValues.rent_upfuel <= 0) {
    //     return {
    //         valid: false,
    //         message: 'Veuillez entrer un montant de carburant valide.'
    //     };
    // }
    if(formValues.rent_type === 'other' && !formValues.rent_designation) {
        return {
            valid: false,
            message: 'Veuillez entrer une désignation pour le type de location "À déterminer".'
        };
    }

    return { valid: true };
};

export const verifyMissingKm = (timesheetDestinations) => {
     const missingKm = timesheetDestinations.some((destination) => {
      const hasTransport =
        destination?.transport_id ||
        destination?.mission_rent_id ||
        (Array.isArray(destination?.transports) && destination.transports.length > 0);
      if (!hasTransport) {
        return false;
      }
      const kmValue =
        destination?.mission_timesheet_details_km ?? destination?.distance_km;
      return isEmpty(kmValue) || Number(kmValue) === 0;
    });
    return missingKm;
};

const isEmpty = (value) => {
    return (
        value === null ||
        value === undefined ||
        (typeof value === 'string' && value.trim() === '') ||
        (typeof value === 'number' && isNaN(value))
    );
};
